import { PopAlert } from '@pwc/appkit-react/lib/Alert';

import { ADD_NOTIFICATION, REMOVE_NOTIFICATION, CLEAR_NOTIFICATION } from './types';

const defaultDuration = 3500;

const baseAlertClassName = 'appkit-animation animated bounceIn appkit appkit-alert-custom-wrapper';

const notification = type => (
  message,
  { closeable = false, duration = defaultDuration, alertClassName = '' } = {
    closeable: false,
    duration: defaultDuration,
  },
) => dispatch => {
  PopAlert({
    oneLineDisplay: true,
    duration,
    status: type,
    message,
    closeable,
    className: [baseAlertClassName, alertClassName].filter(Boolean).join(' '),
    onClose: () =>
      dispatch({
        type: REMOVE_NOTIFICATION,
      }),
  });

  dispatch({
    type: CLEAR_NOTIFICATION,
  });

  dispatch({
    type: ADD_NOTIFICATION,
    payload: {
      type,
      message,
      closeable,
      duration,
    },
  });
};

export const infoNotification = notification('info');

export const successNotification = notification('success');

export const uploadStartedNotification = notification('info');

export const errorNotification = notification('error');
